(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["../hmodules/components/h-charts/partials/chart-group-bars.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"bars");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("bar", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += " ";
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("barIndex", t_5, true);
if(frame.topLevel) {
context.setVariable("barIndex", t_5);
}
if(frame.topLevel) {
context.addExport("barIndex", t_5);
}
output += " ";
var t_6;
t_6 = (runtime.contextOrFrameLookup(context, frame, "groupWidthValue") - runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"column_spacing"));
frame.set("barsGroupWidthValue", t_6, true);
if(frame.topLevel) {
context.setVariable("barsGroupWidthValue", t_6);
}
if(frame.topLevel) {
context.addExport("barsGroupWidthValue", t_6);
}
output += " ";
var t_7;
t_7 = (((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"bars")),"length") - 1) * runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"bars_spacing")) / runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"bars")),"length"));
frame.set("barWidthOffset", t_7, true);
if(frame.topLevel) {
context.setVariable("barWidthOffset", t_7);
}
if(frame.topLevel) {
context.addExport("barWidthOffset", t_7);
}
output += " ";
var t_8;
t_8 = (runtime.contextOrFrameLookup(context, frame, "barsGroupWidthValue") * (runtime.memberLookup((t_4),"width_weight") / runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"totalBarsWidth"))) - runtime.contextOrFrameLookup(context, frame, "barWidthOffset");
frame.set("barWidthValue", t_8, true);
if(frame.topLevel) {
context.setVariable("barWidthValue", t_8);
}
if(frame.topLevel) {
context.addExport("barWidthValue", t_8);
}
output += " ";
var t_9;
t_9 = (runtime.contextOrFrameLookup(context, frame, "barIndex") * (runtime.contextOrFrameLookup(context, frame, "barWidthValue") + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"bars_spacing"))) + (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"column_spacing") / 2);
frame.set("barXValue", t_9, true);
if(frame.topLevel) {
context.setVariable("barXValue", t_9);
}
if(frame.topLevel) {
context.addExport("barXValue", t_9);
}
output += " ";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"values")),runtime.contextOrFrameLookup(context, frame, "groupIndex"))),"v");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("barValue", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
output += " ";
var t_14;
t_14 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.memberLookup((runtime.memberLookup((t_4),"code")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")))),"axis");
frame.set("axisCode", t_14, true);
if(frame.topLevel) {
context.setVariable("axisCode", t_14);
}
if(frame.topLevel) {
context.addExport("axisCode", t_14);
}
output += " ";
var t_15;
t_15 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"y_axis")),runtime.contextOrFrameLookup(context, frame, "axisCode"))),"maxValue");
frame.set("maxValue", t_15, true);
if(frame.topLevel) {
context.setVariable("maxValue", t_15);
}
if(frame.topLevel) {
context.addExport("maxValue", t_15);
}
output += " ";
var t_16;
t_16 = runtime.memberLookup((runtime.memberLookup((t_4),"code")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"));
frame.set("valueCode", t_16, true);
if(frame.topLevel) {
context.setVariable("valueCode", t_16);
}
if(frame.topLevel) {
context.addExport("valueCode", t_16);
}
output += " ";
var t_17;
t_17 = (runtime.memberLookup((t_13),"value") / runtime.contextOrFrameLookup(context, frame, "maxValue")) * runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue");
frame.set("barHeight", t_17, true);
if(frame.topLevel) {
context.setVariable("barHeight", t_17);
}
if(frame.topLevel) {
context.addExport("barHeight", t_17);
}
output += " ";
var t_18;
t_18 = runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue") - ((runtime.memberLookup((t_13),"cumulative") / runtime.contextOrFrameLookup(context, frame, "maxValue")) * runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue"));
frame.set("barYValue", t_18, true);
if(frame.topLevel) {
context.setVariable("barYValue", t_18);
}
if(frame.topLevel) {
context.addExport("barYValue", t_18);
}
output += " ";
var t_19;
t_19 = runtime.memberLookup((t_13),"color") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"color");
frame.set("color", t_19, true);
if(frame.topLevel) {
context.setVariable("color", t_19);
}
if(frame.topLevel) {
context.addExport("color", t_19);
}
output += " ";
var t_20;
t_20 = runtime.memberLookup((t_13),"border_color") || runtime.contextOrFrameLookup(context, frame, "color");
frame.set("borderColor", t_20, true);
if(frame.topLevel) {
context.setVariable("borderColor", t_20);
}
if(frame.topLevel) {
context.addExport("borderColor", t_20);
}
output += " ";
var t_21;
t_21 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"stroke_left") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"stroke_top") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"stroke_right") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"stroke_bottom");
frame.set("stroked", t_21, true);
if(frame.topLevel) {
context.setVariable("stroked", t_21);
}
if(frame.topLevel) {
context.addExport("stroked", t_21);
}
output += " <path fill=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "color"), env.opts.autoescape);
output += "\" class=\"chart-bar ";
if(runtime.contextOrFrameLookup(context, frame, "stroked")) {
output += "stroked";
;
}
output += "\" d=\"M ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barXValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barYValue"), env.opts.autoescape);
output += " v -";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barHeight"), env.opts.autoescape);
output += " h ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barWidthValue"), env.opts.autoescape);
output += " v ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barHeight"), env.opts.autoescape);
output += " z\n                        \"> </path> <path class=\"bar-border ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "valueCode"), env.opts.autoescape);
output += "-bar-border bar-border-left\" d=\"M ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barXValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barYValue"), env.opts.autoescape);
output += " L ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barXValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barYValue") - runtime.contextOrFrameLookup(context, frame, "barHeight"), env.opts.autoescape);
output += "\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"stroke_left")) {
output += " stroke=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "borderColor"), env.opts.autoescape);
output += "\" ";
;
}
output += " ></path> <path class=\"bar-border ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "valueCode"), env.opts.autoescape);
output += "-bar-border bar-border-top\" d=\"M ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barXValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barYValue") - runtime.contextOrFrameLookup(context, frame, "barHeight"), env.opts.autoescape);
output += " L ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barXValue") + runtime.contextOrFrameLookup(context, frame, "barWidthValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barYValue") - runtime.contextOrFrameLookup(context, frame, "barHeight"), env.opts.autoescape);
output += "\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"stroke_top")) {
output += " stroke=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "borderColor"), env.opts.autoescape);
output += "\" ";
;
}
output += " ></path> <path class=\"bar-border ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "valueCode"), env.opts.autoescape);
output += "-bar-border bar-border-right\" d=\"M ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barXValue") + runtime.contextOrFrameLookup(context, frame, "barWidthValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barYValue") - runtime.contextOrFrameLookup(context, frame, "barHeight"), env.opts.autoescape);
output += " L ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barXValue") + runtime.contextOrFrameLookup(context, frame, "barWidthValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barYValue"), env.opts.autoescape);
output += "\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"stroke_right")) {
output += " stroke=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "borderColor"), env.opts.autoescape);
output += "\" ";
;
}
output += " ></path> <path class=\"bar-border ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "valueCode"), env.opts.autoescape);
output += "-bar-border bar-border-bottom\" d=\"M ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barXValue") + runtime.contextOrFrameLookup(context, frame, "barWidthValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barYValue"), env.opts.autoescape);
output += " L ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barXValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "barYValue"), env.opts.autoescape);
output += "\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"stroke_bottom")) {
output += " stroke=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "borderColor"), env.opts.autoescape);
output += "\" ";
;
}
output += " ></path> ";
;
}
}
frame = frame.pop();
output += " ";
var t_22;
t_22 = runtime.contextOrFrameLookup(context, frame, "barXValue") + (runtime.contextOrFrameLookup(context, frame, "barWidthValue") / 2);
frame.set("textXValue", t_22, true);
if(frame.topLevel) {
context.setVariable("textXValue", t_22);
}
if(frame.topLevel) {
context.addExport("textXValue", t_22);
}
output += " ";
var t_23;
t_23 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.memberLookup((runtime.memberLookup((t_4),"code")),0))),"axis");
frame.set("axisCode", t_23, true);
if(frame.topLevel) {
context.setVariable("axisCode", t_23);
}
if(frame.topLevel) {
context.addExport("axisCode", t_23);
}
output += " ";
var t_24;
t_24 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"y_axis")),runtime.contextOrFrameLookup(context, frame, "axisCode"))),"maxValue");
frame.set("maxValue", t_24, true);
if(frame.topLevel) {
context.setVariable("maxValue", t_24);
}
if(frame.topLevel) {
context.addExport("maxValue", t_24);
}
output += " ";
var t_25;
t_25 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"values")),runtime.contextOrFrameLookup(context, frame, "groupIndex"))),"total");
frame.set("totalBarsValue", t_25, true);
if(frame.topLevel) {
context.setVariable("totalBarsValue", t_25);
}
if(frame.topLevel) {
context.addExport("totalBarsValue", t_25);
}
output += " ";
var t_26;
t_26 = (runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue") - ((runtime.contextOrFrameLookup(context, frame, "totalBarsValue") / runtime.contextOrFrameLookup(context, frame, "maxValue")) * runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue")) - 10);
frame.set("textYValue", t_26, true);
if(frame.topLevel) {
context.setVariable("textYValue", t_26);
}
if(frame.topLevel) {
context.addExport("textYValue", t_26);
}
output += " ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"values")),runtime.contextOrFrameLookup(context, frame, "groupIndex"))),"title") || runtime.memberLookup((t_4),"show_total")) {
output += " <text x=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "textXValue"), env.opts.autoescape);
output += "\" y=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "textYValue"), env.opts.autoescape);
output += "\" class=\"bars-title\" text-anchor=\"middle\">";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"values")),runtime.contextOrFrameLookup(context, frame, "groupIndex"))),"title")?runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"values")),runtime.contextOrFrameLookup(context, frame, "groupIndex"))),"title"):(env.getFilter("hChartsNumber").call(context, runtime.contextOrFrameLookup(context, frame, "totalBarsValue"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"format")),"bars_total")))), env.opts.autoescape);
output += "</text> ";
;
}
output += " ";
;
}
}
frame = frame.pop();
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
